var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8UnitedArabEmirates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M16,31h26.716C43.532,28.818,44,26.467,44,24s-0.468-4.818-1.284-7H16V31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M24,4c-2.846,0-5.549,0.604-8,1.675V17h26.716C39.875,9.412,32.579,4,24,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M16,42.325C18.451,43.396,21.154,44,24,44c8.579,0,15.875-5.412,18.716-13H16V42.325z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M16,17V5.675C8.939,8.763,4,15.801,4,24c0,8.199,4.939,15.237,12,18.325V31V17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8UnitedArabEmirates);
export default __webpack_public_path__ + "static/media/icons8-united-arab-emirates.481b38082e36f1f7c3db5bf34c9b43f3.svg";
export { ForwardRef as ReactComponent };